import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import {
  localGetMenu,
  localGetRefreshToken,
  localRemoveMenu,
  localRemoveRefreshToken,
  localRemoveToken,
  localSaveRefreshToken,
  localSaveToken,
} from "../../../utils/localStorage";
import { useNavigate } from "react-router-dom";
import { notifyError, notifyWarning } from "../../../components/notification";
import { api } from "../../../services/api/api.index";
import { API_URL } from "../../../services/api/config";
import { DatePicker, Select } from "antd";
import moment from "moment";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const ChartMultiBar = () => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [value, setValue] = useState(null);
  const [filter, setFilter] = useState({
    limit: 10,
  });
  const getData = async () => {
    try {
      let { data } = await api.get(
        `${API_URL}api/v1/reports/top-reward-clients`,
        {
          limit: filter.limit,
          from_date: value
            ? value[0].format("YYYY-MM-DD")
            : moment().add(-1, "M").format("YYYY-MM-DD"),
          to_date: value
            ? value[1].format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
        }
      );
      setDataSource(data);
      console.log("1232331", data);
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          getData();
        } catch (e) {
          navigate("/login");
          notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        notifyError("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại!");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [value, filter]);

  const disabledDate = (current) => {
    return (
      current &&
      (current < moment().add(-365, "d").endOf("day") ||
        current > moment().endOf("day"))
    );
  };

  const data = [
    {
      name: "Page A",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Page B",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Page C",
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Page D",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "Page E",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "Page F",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "Page G",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];
  const renderLegend = (props) => {
    const { payload } = props;
    console.log(payload);
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {payload.map((entry, index) => (
          <div key={`item-${index}`}>
            {index === 0 ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 8px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#8884d8",
                    height: "24px",
                    width: "24px",
                    margin: "0 8px",
                  }}
                ></div>
                <div style={{ fontSize: "14px" }}>Lợi nhuận</div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 8px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#82ca9d",
                    height: "24px",
                    width: "24px",
                    margin: "0 8px",
                  }}
                ></div>
                <div style={{ fontSize: "14px" }}>Khối lượng giao dịch</div>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };
  const CustomTooltip = ({ active, payload, label }) => {
    const isVisible = active && payload && payload.length;
    console.log("12321", payload);
    return (
      <div
        className="custom-tooltip"
        style={{ visibility: isVisible ? "visible" : "hidden" }}
      >
        {isVisible && (
          <div
            style={{
              background: "#fff",
              padding: "12px",
              borderRadius: "4px",
            }}
          >
            <p className="label" style={{ fontSize: "14px" }}>
              {`${label}`}
            </p>
            <p className="desc" style={{ fontSize: "14px" }}>
              Lợi nhuận : {`${payload[0].value}`} $
            </p>
            <p className="desc" style={{ fontSize: "14px" }}>
              Khối lượng giao dịch: {`${payload[1].value}`} lots
            </p>
          </div>
        )}
      </div>
    );
  };
  const CustomYAxisTick = ({ x, y, payload }) => {
    return (
      <text
        x={x}
        y={y}
        textAnchor="end"
        fill="#666"
        fontSize={14}
        style={{ cursor: "pointer" }}
        onClick={() =>
          navigate(
            `/clients/${
              dataSource.find((x) => x?.client_name === payload.value)
                ?.client_id
            }`
          )
        }
      >
        {payload.value}
      </text>
    );
  };
  return (
    <div
      style={{
        position: "relative",
        padding: "8px",
        background: "#fff",
        marginTop: "32px",
      }}
    >
      <div
        style={{
          width: "100%",
          textAlign: "center",
          fontSize: "18px",
          fontWeight: "bold",
        }}
      >
        Danh sách khách hàng lớn
      </div>
      <div
        className="multiMobile"
        style={{
          display: "flex",
          alignItems: "center",
          position: "relative",

          zIndex: 102,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <p style={{ fontSize: "14px" }}>Hiển thị:&nbsp;&nbsp;</p>
          <Select
            defaultValue={10}
            onChange={(e) => setFilter({ ...filter, limit: e })}
            value={filter.limit}
            style={{ width: "60px" }}
            options={[
              {
                value: 10,
                label: "10",
              },
              {
                value: 20,
                label: "20",
              },
              {
                value: 30,
                label: "30",
              },
            ]}
          />
        </div>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <DatePicker.RangePicker
          style={{ width: "240px" }}
          value={value}
          placeholder={[
            moment().add(-1, "M").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ]}
          onChange={(val) => {
            setValue(val);
          }}
          changeOnBlur
        />
      </div>
      {/* {dataSource && dataSource.length > 0 && (
        <div
          style={{
            position: "absolute",
            height:
              dataSource?.length === 0
                ? "0px"
                : filter.limit === 10
                ? "391px"
                : filter.limit === 20
                ? "891px"
                : "1391px",
            width: "120px",
            top: "93px",
            zIndex: "100",
            left: "0",
          }}
        >
          {dataSource.map((x, index) => (
            <div
              style={{
                height:
                  filter.limit === 10
                    ? "39px"
                    : filter.limit === 20
                    ? "44.5px"
                    : "46.35px",
                width: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "right",
              }}
            >
              <p
                className="hoverChangeColor"
                style={{
                  fontSize: "12px",
                  marginRight:
                    filter.limit === 10
                      ? "6px"
                      : filter.limit === 20
                      ? "3px"
                      : "0px",
                  cursor: "pointer",
                }}
                onClick={() => navigate(`/clients/${x.client_id}`)}
              >
                {x.client_name}
              </p>
            </div>
          ))}
        </div>
      )} */}
      <div style={{ width: "100%", height: 500 * (filter.limit / 10)  }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={dataSource}
            layout="vertical"
            barCategoryGap={5}
            margin={{
              top: 10,
              right: 10,
              left: 0,
              bottom: 10,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis
              tick={<CustomYAxisTick />}
              type="category"
              width={200}
              height={100}
              padding={{ left: 20 }}
              dataKey="client_name"
            />
            <Tooltip content={CustomTooltip} />
            <Legend content={renderLegend} />
            <Bar
              dataKey="reward_usd"
              fill="#8884d8"
              activeBar={<Rectangle fill="pink" stroke="blue" />}
            />
            <Bar
              dataKey="volum_lots"
              fill="#82ca9d"
              activeBar={<Rectangle fill="gold" stroke="purple" />}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ChartMultiBar;
